export const categories = [
  "Mobiles & Accessories",
  "Laptops & Computers",
  "Electronics",
  "Headphones & Audio",
  "TVs",
  "Cameras",
  "Watches",
  "Men's Fashion",
  "Women's Fashion",
  "Shoes",
  "Home & Kitchen",
  "Furniture",
  "Beauty & Personal Care",
  "Grocery",
  "Sports & Fitness",
  "Books",
  "Toys & Games",
  "Gaming",
  "Office & Stationery",
  "Appliances",
  "Automotive",
  "Pet Supplies"
];

export const heroSlides = [
  {
    eyebrow: "Kitchen & Dining",
    title: "Shop kitchen must-haves",
    description: "Cookware, appliances, coffee machines, and kitchen essentials.",
    image: "/promotions/kitchen.png",
    cta: "Shop now",
    link: "/search?category=Home%20%26%20Kitchen"
  },
  {
    eyebrow: "Beauty & Personal Care",
    title: "Shop all things beauty",
    description: "Skincare, makeup, fragrances, and personal care essentials.",
    image: "/promotions/beauty.png",
    cta: "Shop now",
    link: "/search?category=Beauty%20%26%20Personal%20Care"
  },
  {
    eyebrow: "Fashion",
    title: "Start looking sharp",
    description: "Trending clothing, footwear, outerwear, and accessories.",
    image: "/promotions/fashion.png",
    cta: "Shop now",
    link: "/search?category=Fashion"
  },
  {
    eyebrow: "Toys & Baby",
    title: "Toys for little ones",
    description: "Educational toys, plushies, games, and learning sets for kids.",
    image: "/promotions/toys.png",
    cta: "Shop now",
    link: "/search?category=Toys%20%26%20Baby"
  },
  {
    eyebrow: "Electronics",
    title: "Supercharge your tech & electronics",
    description: "High-performance laptops, PCs, smartphones, audio, and accessories.",
    image: "/promotions/computers.png",
    cta: "Shop now",
    link: "/search?category=Electronics"
  }
];
